module.exports = __webpack_public_path__ + "static/img/instant4.e764cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant4.png
// module id = Jm4X
// module chunks = 1